<template>
  <div class="view-home">
    <div id="video" class="video-slide">
      <div class="video">
        <video playsinline autoplay muted loop id="introVideo" v-if="content && content.field_video && content.field_video[0]" poster="../assets/video-bkp.jpg">
          <source :src="content.field_video[0].url" type="video/mp4" />
        </video>
      </div>
      <div class="bg">
        <div class="xcontainer">
          <div class="xrow">
            <div class="xcol-sm-12">
              <div class="overlay" v-if="content && content.field_tagline">
                <!-- <h1 class="one animated fadeInRight">2020 marks</h1><br />
						 	<h1 class="two animated fadeInLeft">9 years of impact</h1><br />
						 	<h1 class="three animated fadeInRight">made possible by </h1><br />
						 	<h1 class="four animated fadeInLeft">our people </h1> -->
                <div class="bar"><img src="../assets/home-bar.png" height="20" /></div>
                <span v-for="(line, index) in content.field_tagline" :key="index">
                  <h1 :class="[index % 2 == 0 ? 'fadeInRight' : 'fadeInLeft', 'animated', 'tag-' + index]">{{ line.value }}</h1>
                  <br />
                </span>
                <p class="animated fadeInRight" style="animation-delay:1.2s; max-width:70%;" v-if="content && content.field_description && content.field_description[0]">{{ content.field_description[0].value }}</p>
                <div class="home-icons animated fadeInLeft">
                  <div>
                    <router-link to="/sector/knowledge-economy"><img src="../assets/home-red.png" height="60"/></router-link>
                  </div>
                  <div>
                    <router-link to="/sector/infrastructure"><img src="../assets/home-blue.png" height="60"/></router-link>
                  </div>
                  <div>
                    <router-link to="/sector/agriculture"><img src="../assets/home-green.png" height="60"/></router-link>
                  </div>
                  <div>
                    <router-link to="/sector/tourism-hospitality"><img src="../assets/home-yellow.png" height="60"/></router-link>
                  </div>
                </div>
                <div class="news-flash animated bounceIn" v-show="newsFlash && newsFlash.title" @click="getNewsItem(newsFlash.link)">
                  <div class="bar"><img src="../assets/home-bar.png" height="20" /></div>
                  <h4>{{ newsFlash.title }}</h4>
                  <p>{{ newsFlash.body }}...read more &raquo;</p>
                </div>
                <!-- <div class="arrow-bottom" style="margin-top:20%">
						 		<a href="#" @click="divScrollTo('#box2')" style="color:#FFF;font-size:80%;"><i class="fa fa-chevron-circle-down fa-2x"></i></a>
						 	</div>	 -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="box3" class="box-3">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 fayemi-grid">
            <div class="text" v-html="statement"></div>
            <div>
              <img :src="featured_image" v-if="featured_image" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="box4">
      <div>
        <router-link to="/flagship-projects">
          <img src="../assets/home1.jpg" />
          <div class="label red">
            <div>Flagship Projects</div>
            <div><i class="fas fa-chevron-right"></i></div>
          </div>
        </router-link>
      </div>
      <div>
        <router-link to="/ease-of-business">
          <img src="../assets/home2.jpg" />
          <div class="label yellow">
            <div>Ease of Doing Business</div>
            <div><i class="fas fa-chevron-right"></i></div>
          </div>
        </router-link>
      </div>
      <div>
        <router-link to="/business-in-ekiti">
          <img src="../assets/home3.jpg" />
          <div class="label green">
            <div>Doing Business in Ekiti</div>
            <div><i class="fas fa-chevron-right"></i></div>
          </div>
        </router-link>
      </div>
    </div>
    <div id="box2" class="box-2">
      <div class="box-2-bg">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <h5 id="box2Animate" v-animate="'fade-in'">Headlines</h5>
              <div class="news-grid">
                <div class="news" v-for="item in news" :key="item.nid">
                  <router-link to="" @click.native="getNewsItem(item.alias)"><span v-html="item.title"></span></router-link>
                </div>
                <!-- <div class="news"><router-link to="/news/fayemi-flags-ekiti-cargo-airport-project">Fayemi flags off Ekiti Cargo Airport Project</router-link></div>
			  				<div class="news"><router-link to="/news/dangote-coscharis-stallion-group-set-rice-mill-ekiti">Dangote, Coscharis, Stallion Group to set up rice mill in Ekiti
</router-link></div>
			  				<div class="news">
			  					<router-link to="/news/ekiti-leads-taking-down-internet-access-barriers-all">Ekiti Leads on Taking Down Internet Access Barriers to All
			  					</router-link></div>
			  				<div class="news"><router-link to="/news/ekiti-woos-investors-ease-doing-business">Ekiti woos investors with ease of doing business</router-link></div> -->
              </div>
              <div class="center"><router-link to="/media">View all News &raquo;</router-link></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="indicators">
		<div id="arrow-up" v-show="currentBox > 1"><a href="#" @click="divScrollTo('up')"><i class="fas fa-chevron-up fa-2x"></i></a></div>
		<div id="arrow-down"  v-show="currentBox < 3"><a href="#" @click="divScrollTo('down')" ><i class="fas fa-chevron-down fa-2x"></i></a></div>
	</div> -->
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  name: "home",
  components: {
    // KeyIndustries
  },
  data: function() {
    return {
      browserHeight: window.screen.availHeight,
      scrollPos: 0,
      currentBox: 1,
      box1top: 0,
      box1bottom: 0,
      box2top: 0,
      box2bottom: 0,
      box3top: 0,
      box3bottom: 0,
      halfBox1: 0,
      halfBox2: 0,
      halfBox3: 0,
      content: null,
      statement: null,
      featured_image: null,
      expertiseObj: {},
      subExpertise: [],
      news: [],
      newsFlash: {
        title: null,
        link: null,
        body: null,
      },
    }
  },

  methods: {
    handleScroll() {
      var box1 = document.getElementById("video")
      var localbox1top = box1.getBoundingClientRect().top
      var absPosition = Math.abs(localbox1top)

      if (absPosition < 85) {
        this.currentBox = 1
      } else if (absPosition >= 85 && absPosition < this.box2top + 150) {
        this.currentBox = 2
      } else {
        this.currentBox = 3
      }
    },
    divScrollTo(dir) {
      var goToBox = dir == "up" ? this.currentBox - 1 : this.currentBox + 1
      var id = goToBox == 1 ? "#video" : "#box" + goToBox
      this.$scrollTo(id)
    },
    async loadContent() {
      const { data } = await ContentRepository.getNode(1)

      this.content = data

      // console.log('data', data)
    },
    async getNewsFlash() {
      // console.log('get news flash')
      const { data } = await ContentRepository.getNewsFlash()

      // console.log('flash', data)

      if (data && data.length > 0) {
        this.newsFlash.title = data[0].title
        this.newsFlash.link = data[0].link
        this.newsFlash.body = data[0].body
      }
    },

    async getGroup(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.news = data.splice(0, 4)
      // console.log('data', data)

      // this.getSiblings()
    },
    // getInsights(){
    // 	console.log('get insights')
    // },
    getNewsItem(alias) {
      var aliasName = alias.split("/").pop()
      var path = "/news/" + aliasName

      this.$router.push(path)
    },
    async getChairmanDetails() {
      // var id = "2"
      const { data } = await ContentRepository.getNode(133)
      // console.log('home page data', data)

      this.statement = data.body && data.body[0] && data.body[0].value ? data.body[0].value : null
      this.featured_image = data.field_feature_image && data.field_feature_image[0] && data.field_feature_image[0].url ? data.field_feature_image[0].url : null

      // this.getSiblings()
    },
    // getExpertise(){
    // 	var navigation = this.$session.get('navigation')
    // 	if (navigation && navigation.length){
    // 		var expertArr = navigation.filter(function (item){
    //         return item.name.toLowerCase() == 'our expertise'
    //       })

    //       this.expertiseObj = expertArr[0]

    //       var expertChildren =  this.expertiseObj.children

    //       this.subExpertise = navigation.filter(function (item){
    // 	return expertChildren.includes(item.nid)
    // })

    //       // console.log('sub expertise', this.subExpertise)
    // 	}

    // },
  },

  mounted() {
    this.loadContent()
    this.getGroup("news")
    this.getNewsFlash()
    this.getChairmanDetails()

    window.scrollTo(0, 0)

    // var box1 = document.getElementById('video')
    // this.box1top = (box1.getBoundingClientRect()).top
    // this.box1bottom = (box1.getBoundingClientRect()).bottom
    // this.halfBox1 = (this.box1bottom - this.box1top) / 2

    // var box2 = document.getElementById('box2')
    // this.box2top = (box2.getBoundingClientRect()).top
    // this.box2bottom = (box2.getBoundingClientRect()).bottom
    // this.halfBox2 = (this.box2bottom - this.box2top) / 2

    // var box3 = document.getElementById('box3')
    // this.box3top = (box3.getBoundingClientRect()).top
    // this.box3bottom = (box3.getBoundingClientRect()).bottom
    // this.halfBox3 = (this.box3bottom - this.box3top) / 2

    // window.addEventListener('scroll', this.handleScroll)
  },
}
</script>

<style>
.news-grid a,
.center a {
  color: #000;
}

#box4 a:hover {
  text-decoration: none;
}

.center {
  text-align: center;
}

.news-flash {
  cursor: pointer;
  padding-right: 10px;
  color: #ffcc00;
  max-width: 70%;
  animation-delay: 1.2s;
}

@media (max-width: 762px) {
  .news-flash {
    max-width: 90%;
  }
}
</style>
